/**
 * @enum {string} - event names
 */
export var CIDPrinterListenerTypes;
(function (CIDPrinterListenerTypes) {
    CIDPrinterListenerTypes["PRINTER_LIBRARY"] = "printerLibraryEvent";
})(CIDPrinterListenerTypes || (CIDPrinterListenerTypes = {}));
;
/**
 * @enum {number} - Licstat
 */
export var LicenseStatus;
(function (LicenseStatus) {
    LicenseStatus[LicenseStatus["LICENSE_INVALID"] = 1] = "LICENSE_INVALID";
    LicenseStatus[LicenseStatus["LICENSE_VALID"] = 2] = "LICENSE_VALID";
    LicenseStatus[LicenseStatus["LICENSE_EVAL_INVALID"] = 3] = "LICENSE_EVAL_INVALID";
    LicenseStatus[LicenseStatus["LICENSE_EVAL_VALID"] = 4] = "LICENSE_EVAL_VALID";
    LicenseStatus[LicenseStatus["LICENSE_EXPIRED"] = 5] = "LICENSE_EXPIRED";
})(LicenseStatus || (LicenseStatus = {}));
;
export var EventType;
(function (EventType) {
    EventType[EventType["SUCCESS"] = 0] = "SUCCESS";
    EventType[EventType["NOTIFY"] = 1] = "NOTIFY";
    EventType[EventType["FAILED"] = 2] = "FAILED";
})(EventType || (EventType = {}));
;
export var PrinterLibraryActionType;
(function (PrinterLibraryActionType) {
    PrinterLibraryActionType[PrinterLibraryActionType["NONE"] = 0] = "NONE";
    PrinterLibraryActionType[PrinterLibraryActionType["INITIALIZE"] = 1] = "INITIALIZE";
    PrinterLibraryActionType[PrinterLibraryActionType["BLUETOOTH_INITIALIZE"] = 2] = "BLUETOOTH_INITIALIZE";
    PrinterLibraryActionType[PrinterLibraryActionType["BLUETOOTH_ENABLE"] = 3] = "BLUETOOTH_ENABLE";
    PrinterLibraryActionType[PrinterLibraryActionType["BLUETOOTH_DISABLE"] = 4] = "BLUETOOTH_DISABLE";
    PrinterLibraryActionType[PrinterLibraryActionType["DISCOVER_START"] = 5] = "DISCOVER_START";
    PrinterLibraryActionType[PrinterLibraryActionType["DISCOVER_DETECT"] = 6] = "DISCOVER_DETECT";
    PrinterLibraryActionType[PrinterLibraryActionType["DISCOVER_FINISH"] = 7] = "DISCOVER_FINISH";
    PrinterLibraryActionType[PrinterLibraryActionType["CONNECT"] = 8] = "CONNECT";
    PrinterLibraryActionType[PrinterLibraryActionType["DISCONNECT"] = 9] = "DISCONNECT";
    PrinterLibraryActionType[PrinterLibraryActionType["PRINT"] = 10] = "PRINT";
    PrinterLibraryActionType[PrinterLibraryActionType["STATUS"] = 11] = "STATUS";
    PrinterLibraryActionType[PrinterLibraryActionType["CONFIGURE"] = 12] = "CONFIGURE";
    PrinterLibraryActionType[PrinterLibraryActionType["BLUETOOTH_TURNED_OFF"] = 13] = "BLUETOOTH_TURNED_OFF";
    PrinterLibraryActionType[PrinterLibraryActionType["BLUETOOTH_TURNED_ON"] = 14] = "BLUETOOTH_TURNED_ON";
    PrinterLibraryActionType[PrinterLibraryActionType["LICENSE_ACTIVATION"] = 15] = "LICENSE_ACTIVATION";
    PrinterLibraryActionType[PrinterLibraryActionType["FILEUPLOAD"] = 16] = "FILEUPLOAD";
    PrinterLibraryActionType[PrinterLibraryActionType["EXCEPTION"] = 17] = "EXCEPTION";
})(PrinterLibraryActionType || (PrinterLibraryActionType = {}));
;
export var PrinterStatusType;
(function (PrinterStatusType) {
    PrinterStatusType[PrinterStatusType["OK"] = 0] = "OK";
    PrinterStatusType[PrinterStatusType["OK_WAITING_TO_DISPENSE"] = 1] = "OK_WAITING_TO_DISPENSE";
    PrinterStatusType[PrinterStatusType["OK_STILL_PRINTING"] = 2] = "OK_STILL_PRINTING";
    PrinterStatusType[PrinterStatusType["COVER_OPEN"] = 4] = "COVER_OPEN";
    PrinterStatusType[PrinterStatusType["PAPER_OUT_BEFORE_PRINT"] = 5] = "PAPER_OUT_BEFORE_PRINT";
    PrinterStatusType[PrinterStatusType["PAPER_OUT"] = 6] = "PAPER_OUT";
    PrinterStatusType[PrinterStatusType["OFFLINE"] = 7] = "OFFLINE";
    PrinterStatusType[PrinterStatusType["RESET"] = 8] = "RESET";
    PrinterStatusType[PrinterStatusType["ISONLINE"] = 9] = "ISONLINE";
    PrinterStatusType[PrinterStatusType["BATTERY_NOT_OK"] = 10] = "BATTERY_NOT_OK";
    PrinterStatusType[PrinterStatusType["PRINTER_OK"] = 11] = "PRINTER_OK";
    PrinterStatusType[PrinterStatusType["ERROR"] = 12] = "ERROR";
    PrinterStatusType[PrinterStatusType["NO_CONNECTION"] = 13] = "NO_CONNECTION";
    PrinterStatusType[PrinterStatusType["NOT_REGISTERED"] = 14] = "NOT_REGISTERED";
    PrinterStatusType[PrinterStatusType["COMMAND_FAILED"] = 15] = "COMMAND_FAILED";
    PrinterStatusType[PrinterStatusType["PRINT_HALT"] = 16] = "PRINT_HALT";
    PrinterStatusType[PrinterStatusType["NO_RESPONSE"] = 17] = "NO_RESPONSE";
    PrinterStatusType[PrinterStatusType["MEDIA_ERROR"] = 18] = "MEDIA_ERROR";
    PrinterStatusType[PrinterStatusType["LABEL_NOT_DETECTED"] = 19] = "LABEL_NOT_DETECTED";
    PrinterStatusType[PrinterStatusType["CONNECTED"] = 20] = "CONNECTED";
    PrinterStatusType[PrinterStatusType["STATUS_UNKNOWN"] = 99] = "STATUS_UNKNOWN";
})(PrinterStatusType || (PrinterStatusType = {}));
;
export var ReferenceTicketType;
(function (ReferenceTicketType) {
    ReferenceTicketType[ReferenceTicketType["DOT_MATRIX"] = 0] = "DOT_MATRIX";
})(ReferenceTicketType || (ReferenceTicketType = {}));
export var MediaType;
(function (MediaType) {
    MediaType[MediaType["GAP"] = 0] = "GAP";
    MediaType[MediaType["IMARK"] = 1] = "IMARK";
})(MediaType || (MediaType = {}));
export var PrinterVendor;
(function (PrinterVendor) {
    PrinterVendor[PrinterVendor["UNKNOWN"] = 0] = "UNKNOWN";
    PrinterVendor[PrinterVendor["ZEBRA"] = 1] = "ZEBRA";
    PrinterVendor[PrinterVendor["SATO"] = 2] = "SATO";
    PrinterVendor[PrinterVendor["HONEYWELL"] = 3] = "HONEYWELL";
    PrinterVendor[PrinterVendor["GOOJPRT"] = 4] = "GOOJPRT";
    PrinterVendor[PrinterVendor["ESCPOS"] = 5] = "ESCPOS";
})(PrinterVendor || (PrinterVendor = {}));
export var SatoPrinterModel;
(function (SatoPrinterModel) {
    SatoPrinterModel[SatoPrinterModel["UNKNOWN"] = 0] = "UNKNOWN";
    SatoPrinterModel[SatoPrinterModel["MB200i"] = 1] = "MB200i";
    SatoPrinterModel[SatoPrinterModel["PW208NX"] = 2] = "PW208NX";
    SatoPrinterModel[SatoPrinterModel["CT4LX"] = 3] = "CT4LX";
})(SatoPrinterModel || (SatoPrinterModel = {}));
(function (SatoPrinterModel) {
    function valueOf(str) {
        return SatoPrinterModel[str];
    }
    SatoPrinterModel.valueOf = valueOf;
    function values() {
        let res = [];
        for (const value in Object.values(SatoPrinterModel)) {
            if (isNaN(Object.values(SatoPrinterModel)[value]) && typeof (Object.values(SatoPrinterModel)[value]) !== 'function') {
                res.push(Object.values(SatoPrinterModel)[value]);
            }
        }
        return res;
    }
    SatoPrinterModel.values = values;
})(SatoPrinterModel || (SatoPrinterModel = {}));
export var HoneywellPrinterModel;
(function (HoneywellPrinterModel) {
    HoneywellPrinterModel[HoneywellPrinterModel["UNKNOWN"] = 0] = "UNKNOWN";
    HoneywellPrinterModel[HoneywellPrinterModel["PC23D"] = 1] = "PC23D";
    HoneywellPrinterModel[HoneywellPrinterModel["PF4i"] = 2] = "PF4i";
    HoneywellPrinterModel[HoneywellPrinterModel["PM43C"] = 3] = "PM43C";
})(HoneywellPrinterModel || (HoneywellPrinterModel = {}));
(function (HoneywellPrinterModel) {
    function valueOf(str) {
        return HoneywellPrinterModel[str];
    }
    HoneywellPrinterModel.valueOf = valueOf;
    function values() {
        let res = [];
        for (const value in Object.values(HoneywellPrinterModel)) {
            if (isNaN(Object.values(HoneywellPrinterModel)[value]) && typeof (Object.values(HoneywellPrinterModel)[value]) !== 'function') {
                res.push(Object.values(HoneywellPrinterModel)[value]);
            }
        }
        return res;
    }
    HoneywellPrinterModel.values = values;
})(HoneywellPrinterModel || (HoneywellPrinterModel = {}));
export class DeviceResult {
}
export class PrinterCapabilities {
    constructor(dots, dpi, dpm, labelwidth, labelheight) {
        this.dots = dots;
        this.dpi = dpi;
        this.dpm = dpm;
        this.labelwidth = labelwidth;
        this.labelheight = labelheight;
    }
}
export class ConfigurationResult {
    constructor(capabilities) {
        this.capabilities = capabilities;
    }
}
export class BluetoothResult {
    constructor(adapteraddress, adaptername) {
        this.adapteradress = adapteraddress;
        this.adaptername = adaptername;
    }
    setBondedDevices(devices) {
        this.paireddevices = devices;
    }
}
export class Device {
    constructor(name, address, bluetoothclass, type, vendor, model) {
        this.name = name;
        this.address = address;
        this.bluetoothclass = bluetoothclass;
        this.type = type;
        this.vendor = vendor;
        this.model = model;
    }
    getPrinterModel() {
        switch (this.vendor) {
            case PrinterVendor.SATO:
                return SatoPrinterModel.values()[this.model];
            case PrinterVendor.HONEYWELL:
                return HoneywellPrinterModel.values()[this.model];
        }
    }
}
//# sourceMappingURL=enums.js.map